// removed by extract-text-webpack-plugin
module.exports = {"HomePage":"HomePage__HomePage__2_P9q","Logo":"HomePage__Logo__2u_xu"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/HomePage/HomePage.css
// module id = 64
// module chunks = 0